import { AppNotification, Notification, NotificationSetting } from "./notification.model";
import { AppNav } from "./app-nav";
import {  Permission } from "./access-permission";
import { JobTag } from "./directory-user.model";

export class UserData {
    User?: string;
      UID: number;
      PM?: boolean;
      MainFID?: number;
      DraftAssignment?: boolean;
      IsDrafter?: boolean;
      FirstName?: string;
      LastName?: string;
      defaultFID?: number;
      isDev?: boolean;
      DisplayName: string;
      Beta?: boolean;
      Title?: string;
      Role?: string;
      isAdmin?: boolean;
      TaxOverride?: boolean;
      Archived?: boolean;
      DepartmentID?: boolean;
      PartTime?: boolean;
      Manager?: string;
      ShowTravel?: boolean;
      StandardIncluded?: boolean;
      Dark?:boolean;
      PrintFormat?: string;
      isCaseManager?: boolean;
      DefaultDraftScreen?: string;
      profilePicture?: string;
	  id?: string;
      permissions?: Permission[];
      notifications?: Notification[];
      notificationSettings?: NotificationSetting[];
      businessPhones?: any[];
      displayName: string;
      surname?: string;
      givenName?: string;
      jobTitle?: string;
      mail: string;
      mobilePhone?: string;
      officeLocation?: string;
      department?: string;
      UserRoles?: UserRole[];
      employeeHireDate?: string;
      appNotifications?: AppNotification[];
      ShowPrice?: boolean;
      officeInvites_officeInvites_targetUserToUsers?: InviteRoles[];
      userPrincipalName?: string;
      AzureID?: string;
      defaultBinderViewId?: number;
      [key: string]: any;
      constructor(
        User: string = '',
        UID: number = 0,
        PM: boolean = false,
        MainFID: number = 0,
        DraftAssignment: boolean = false,
        IsDrafter: boolean = false,
        FirstName: string = '',
        LastName: string = '',
        defaultFID: number = 0,
        isDev: boolean = false,
        DisplayName: string = '',
        Beta: boolean = false,
        Title: string = '',
        Role: string = '',
        isAdmin: boolean = false,
        TaxOverride: boolean = false,
        Archived: boolean = false,
        DepartmentID: boolean = false,
        PartTime: boolean = false,
        Manager: string = '',
        ShowTravel: boolean = false,
        StandardIncluded: boolean = false,
        Dark: boolean = false,
        PrintFormat: string = '',
        isCaseManager: boolean = false,
        DefaultDraftScreen: string = '',
        profilePicture: string = '',
        id: string = '',
        permissions: Permission[] = [],
        notifications: Notification[] = [],
        notificationSettings: NotificationSetting[] = [],
        businessPhones: any[] = [],
        displayName: string = '',
        surname: string = '',
        givenName: string = '',
        jobTitle: string = '',
        mail: string = '',
        mobilePhone: string = '',
        officeLocation: string = '',
        department: string = '',
        employeeHireDate: string = ''
    ) {
        this.User = User;
        this.UID = UID;
        this.PM = PM;
        this.MainFID = MainFID;
        this.DraftAssignment = DraftAssignment;
        this.IsDrafter = IsDrafter;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.defaultFID = defaultFID;
        this.isDev = isDev;
        this.DisplayName = DisplayName;
        this.Beta = Beta;
        this.Title = Title;
        this.Role = Role;
        this.isAdmin = isAdmin;
        this.TaxOverride = TaxOverride;
        this.Archived = Archived;
        this.DepartmentID = DepartmentID;
        this.PartTime = PartTime;
        this.Manager = Manager;
        this.ShowTravel = ShowTravel;
        this.StandardIncluded = StandardIncluded;
        this.Dark = Dark;
        this.PrintFormat = PrintFormat;
        this.isCaseManager = isCaseManager;
        this.DefaultDraftScreen = DefaultDraftScreen;
        this.profilePicture = profilePicture;
        this.id = id;
        this.permissions = permissions;
        this.notifications = notifications;
        this.notificationSettings = notificationSettings;
        this.businessPhones = businessPhones;
        this.displayName = displayName;
        this.surname = surname;
        this.givenName = givenName;
        this.jobTitle = jobTitle;
        this.mail = mail;
        this.mobilePhone = mobilePhone;
        this.officeLocation = officeLocation;
        this.department = department;
        this.employeeHireDate = employeeHireDate;
    }
}

export interface InviteRoles {
          Users_officeInvites_senderToUsers: {
              DisplayName: string
          },
          Users_officeInvites_targetUserToUsers: {
              DisplayName: string
          },
          inviteRoles: {
              PermRoles: PermRole,
              inviteId:number,
              inviteRoleId:number,
              roleId:number,
          }[],
          sendDate: Date,
          targetUser:number,
          sender:number,
          inviteId:number

}

export class PermRole {
    location?: boolean;
        RoleName: string;
        PermRoleID: number;
        locationContentGroupId: number | null;
        tagId: number | null;
        roleAppNav: RoleAppNav[];
        RoleAccess?: RoleAccess[]
        jobTags: JobTag[];
        UserRoles?:UserRole[];
        FID: number | null;
        Franchises?: {
                CityCode: string,
                Title: string
        }
constructor() {
        this.RoleName= '',
        this.PermRoleID = 0,
        this.roleAppNav = [];
        this.FID = null;
        this.location = false;
        this.locationContentGroupId = null;
        this.tagId = null;
        this.jobTags = [];
}
}

export interface RoleAppNav {
    appNavId: number,
    PermRoleID: number,
    roleAppNavId: number,
    appNav: AppNav
}

export interface UserRole {
    UID: number,
    PermRoleID: number,
    UserRoleID: number,
    PermRoles: PermRole,
    inviteRole?: boolean,
    invite?: InviteRoles
}

export interface RoleAccess {
    PermRoleID: number,
    AccessPermID: number,
    RoleAccessID: number,
    AccessPermissions:AccessPermission,
    PermRole?: PermRole
}

export interface AddRole {
    PermRoleID: number;
  FID: number | null;
  inviteRequired: boolean;
}

export interface AccessPermission {
  AccessPermID: number,
  PermTitle: string,
  permDesc: string,
  permType: string,
  FID: number,
  dataTable: string
}


export interface RemoveRole {
  UserRoleID: number;
PermRoleID: number;
FID: number | null;
}

export interface RoleExpanded { 
  RoleName: string; 
  officeName: string;
  userRole?: UserRole; 
  Access: { 
      table: string; 
      perms: string[]; 
  }[]; 
}

export interface ExtractedPerms {
  table: string;
  type: string;
  fid: number;
}